<script lang="ts" setup>
const props = defineProps<{
  id: number
  src: string
  size?: number | string
  link?: boolean
}>()

function goToDetail() {
  if (props.link) {
    open(`/member/${props.id}`)
  }
}
</script>

<template>
  <MImg
    :key="src"
    class="m-avatar"
    :size="size || 34"
    :src="src"
    @click="goToDetail"
  />
</template>

<style lang="scss" scoped>
.m-avatar {
  border-radius: 50%;
  cursor: pointer;
}
</style>
